import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useGetAllProductsList } from "../../../hooks/product/useGetAllProductsList";

type PaymentProductsFilterProps = {
    onChange: (value: string) => void;
    value?: string;
    onClear?: (value?: any) => void;
};

const SelectBoxWrapper = styled.div`
  max-width: 300px;
  min-width: 225px;
`;

export const PaymentProductsFilter: React.FC<PaymentProductsFilterProps> = ({
    value,
    onChange,
    onClear,
}) => {
    const { t } = useTranslation();
    const allProducts = useGetAllProductsList("payments", "name.asc", 999);


    const productsOptions = allProducts?.data?.map((product) => ({
        value: product.code,
        label: product.name,
    }));

    return (
        <SelectBoxWrapper>
            <Select
                // mode="multiple"
                allowClear
                placeholder={t("licenses.basic.search.product.title")}
                style={{ width: "100%" }}
                maxTagCount={1}
                options={productsOptions}
                onChange={onChange}
                value={value}
                onClear={(value?: any) => {
                    if (onClear) {
                        onClear(value);
                    }
                }}
            />
        </SelectBoxWrapper>
    );
};
